import { render, staticRenderFns } from "./ReceiveList.vue?vue&type=template&id=c0e151e2&scoped=true&"
import script from "./ReceiveList.vue?vue&type=script&lang=js&"
export * from "./ReceiveList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveList.vue?vue&type=style&index=0&id=c0e151e2&lang=scss&scoped=true&"
import style1 from "./ReceiveList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e151e2",
  null
  
)

export default component.exports